import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Divider,
  CircularProgress
} from "@mui/material";
import { spandanAiDetails } from "api/reports";
import { useSnackbar } from "components/snackbar";

const getColor = (val) => {
  if (val >= 95) return "#2e7d32"; // green
  if (val >= 50) return "#f57c00"; // orange
  return "#d32f2f"; // red
};

const formatLeadName = (key) => {
  const base = key.replace("_data", "").toLowerCase();

  if (base.startsWith("v")) return base.toUpperCase();
  if (base.startsWith("lead")) return "L" + base.replace("lead", "");

  if (base === "avr") return "aVR";
  if (base === "avl") return "aVL";
  if (base === "avf") return "aVF";

  return base;
};

const LeadQualityClassification = ({ data }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [predictionsData, setPredictionsData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!data || !data.paths) return;

    const fetchData = async () => {
      const paths = Object.values(data.paths);

      setLoading(true);

      try {
        const response = await spandanAiDetails({
          path: paths,
          report_type: data?.report_type,
        });

        if (response?.status === 200) {
          setPredictionsData(
            response?.data?.predicted_response || {}
          );
        } else {
          enqueueSnackbar(response?.message || "API Error", {
            variant: "error",
          });
        }
      } catch (err) {
        enqueueSnackbar("Something went wrong", {
          variant: "error",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [data]);

  const leadMap = {};

  Object.entries(predictionsData || {}).forEach(([key, value]) => {
    const lead = formatLeadName(key);

    let val = value?.prediction?.[1] || 0;
    val = val <= 1 ? val * 100 : val;

    leadMap[lead] = val;
  });

  const columns = [
    ["V1", "V2", "V3"],
    ["V4", "V5", "V6"],
    ["L1", "L2", "L3"],
    ["aVR", "aVL", "aVF"],
  ];

  if (loading) {
    return (
      <Box textAlign="center" mt={3}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box p={1} bgcolor="#fafafa" borderRadius={2}>
      <Typography variant="h6" mb={2}>
        Lead Quality Classification
      </Typography>

      <Grid container>
        {columns.map((col, idx) => (
          <Grid item xs={12} md={3} key={idx}>
            <Box
              px={1}
              sx={{
                borderRight:
                  idx !== columns.length - 1 ? "1px solid #e0e0e0" : "none",
              }}
            >
              {/* Header */}
              <Box
                display="flex"
                justifyContent="space-between"
                mb={1}
              // style={{borderRight:'1px solid gray'}}
              >
                <Typography variant="subtitle2">
                  Lead
                </Typography>
                <Typography variant="subtitle2">
                  Acceptance
                </Typography>
              </Box>

              {/* Rows */}
              {col.map((lead) => (
                <Box
                  key={lead}
                  display="flex"
                  justifyContent="space-between"
                  mb={1}
                // style={{borderRight:'1px solid gray'}}
                >
                  <Typography variant="body2">
                    {lead}
                  </Typography>

                  <Typography
                    variant="body2"
                    fontWeight={600}
                    sx={{
                      color: getColor(leadMap[lead] || 0),
                    }}
                  >
                    {(leadMap[lead] || 0).toFixed(0)}%
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* Divider */}
            {idx !== columns.length - 1 && (
              <Divider
                orientation="vertical"
                flexItem
                sx={{ borderColor: "#e0e0e0" }}
              />
            )}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LeadQualityClassification;